// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  height: calc(100% - 2 * var(--content-margin));
}

.form-field {
  width: 360px;
}

.notes-form-field {
  width: 100%;
}

.error {
  background-color: white;
  color: red;
}

#button-row {
  padding: 0 20px;
  margin-top: 10px;
}

form {
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/models/vault-detail/vault-detail.component.scss"],"names":[],"mappings":"AAAA;EACE,8CAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,uBAAA;EACA,UAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;AACF","sourcesContent":[".content {\n  height: calc(100% - 2 * var(--content-margin));\n}\n\n.form-field {\n  width: 360px;\n}\n\n.notes-form-field {\n  width: 100%;\n}\n\n.error {\n  background-color: white;\n  color: red;\n}\n\n#button-row {\n  padding: 0 20px;\n  margin-top: 10px;\n}\n\nform {\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
